import { useEffect, useState } from "react"

/** Возвращает true, когда на мобильном устройстве открыта клавиатура */
export function useIsKeyboardOpen(): boolean {
    const [open, setOpen] = useState(false)

    useEffect(() => {
        const vv = window.visualViewport
        if (!vv) return

        const update = () => {
            setOpen(vv.height < window.innerHeight * 0.8)
        }

        vv.addEventListener("resize", update)
        update()

        return () => vv.removeEventListener("resize", update)
    }, [])

    return open
}
